import React from 'react'
import { logout } from '../../actions/authActions'
import { connect, useDispatch } from 'react-redux'
import Button from '../../utils/components/Button/Button';
import { useHistory } from 'react-router-dom';
import { Translate } from '../../language';
import localStorage from '../../utils/hooks/useLocalStorage';
import { getAuth, signOut } from 'firebase/auth';

const Logout = ({ renderClose }) => {
    const history = useHistory()
    const dispatch = useDispatch()
    // dispatch(logout(history))
 
    return (
        <div>
            <Button
                onClick={() => {
                    if(localStorage().getItem("externalLogin") === "google" ||
                       localStorage().getItem("externalLogin") === "facebook"){
                        const auth = getAuth();
                        signOut(auth).then(() => {
                            dispatch(logout(history))
                        }).catch((error) => {
                          // An error happened.
                        })
                    }
                    else{
                        dispatch(logout(history))
                    }
                  
                
                }}
                text={Translate('closeSession', 'es')} />
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        googleId: state.social.googleId
    }
}
export default connect(mapStateToProps, { logout })(Logout)
